import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import TableOverview from "../pages/TableOverview";
import Dashboard from "../pages/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/Layout";
import Orders from "../pages/Orders";
import Settings from "../pages/Settings";
// import Reports from "../pages/Reports";
import Menu from "../pages/Menu";
import Login from "../pages/LogIn";
import PartnerOrderDetailed from "../components/PartnerOrderDetailed";
import Reports from "../pages/Reports";
import InventoryLoader from "../components/InventoryLoader";
import ExpensesLoader from "../components/ExpensesLoader";
// import Charts from "../pages/Charts";

const Inventory = () => {
  const authToken = localStorage.getItem("authToken");
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ width: "100%" }} className="h-screen md:h-full">
      <iframe
        src={`https://app-inventory-frontend.pages.dev/?authToken=${authToken}`}
        style={{
          width: "100%",
          height: "100%",
          display: isLoading ? "none" : "block",
        }}
        onLoad={() => setTimeout(() => setIsLoading(false), 2000)}
      />
      <InventoryLoader isLoading={isLoading}></InventoryLoader>
    </div>
  );
};

const Expenses = () => {
  const authToken = localStorage.getItem("authToken");
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ width: "100%" }} className="h-screen md:h-full">
      <iframe
        src={`https://app-expenses-frontend.pages.dev?authToken=${authToken}`}
        style={{
          width: "100%",
          height: "100%",
          display: isLoading ? "none" : "block",
        }}
        onLoad={() => setTimeout(() => setIsLoading(false), 2000)}
      />
      <ExpensesLoader isLoading={isLoading}></ExpensesLoader>
    </div>
  );
}

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Layout />}>
          <Route
            index
            path="/table-overview"
            element={<ProtectedRoute element={TableOverview} />}
          />
          <Route
            path="/dashboard"
            element={<ProtectedRoute element={Dashboard} />}
          />
          <Route
            path="/menu-managment"
            element={<ProtectedRoute element={Menu} />}
          />
          <Route
            path="/setting"
            element={<ProtectedRoute element={Settings} />}
          ></Route>
          <Route
            path="/reports"
            element={<ProtectedRoute element={Reports} requiresPayment={true} />}
          />
          <Route
            path="/order-main"
            element={<ProtectedRoute element={Orders} requiresPayment={true} />}
          />
          <Route
            path="/inventory"
            element={<ProtectedRoute element={Inventory} requiresPayment={true} />}
          />
          <Route
            path="/expenses"
            element={<ProtectedRoute element={Expenses} requiresPayment={true}  />}
          />
          
          {/* <Route path="/charts" element={<ProtectedRoute element={Charts} />} /> */}
          <Route path="*" element={<Navigate to="/table-overview" />} />{" "}
          {/* Redirect to table overview if route is unknown */}
          <Route
            path="/partner-order-detailed"
            element={
              <ProtectedRoute
                element={PartnerOrderDetailed}
                onClose={() => {}}
              />
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
